import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LayoutService } from '@shared/services/layout.service';
import { ADMIN_TOKEN_KEY, ErrorType, TOKEN_KEY } from '@shared/models';
import { Router } from '@angular/router';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { PhoneConfirmationService } from '@shared/pages/phone-confirmation/phone-confirmation.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private layoutService: LayoutService,
              private router: Router,
              private localStorageService: LocalStorageService,
              private phoneConfirmationService: PhoneConfirmationService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 403) {
          if (err.url.includes('givex/verify/user') || err.url.includes('givex/user')) {
            this.localStorageService.removeItem(TOKEN_KEY);
            this.router.navigate([`/promo`]);
          } else if (err.error && err.error.message && err.error.message.toLowerCase().includes('access')) {
            this.layoutService.openErrorDialog(ErrorType.UNKNOWN, err.error.message);
            this.localStorageService.removeItem(ADMIN_TOKEN_KEY);
            this.router.navigate(['/auth/login']);
          } else {
            this.localStorageService.removeItem(ADMIN_TOKEN_KEY);
            this.localStorageService.removeItem(TOKEN_KEY);
            this.router.navigate(['/']);
          }
        } else if ((err.url.includes('givex/qr/summary'))  && err.error && err.error.payload && err.error.payload.toLowerCase().includes('too many')) {
          // prevent requests spamming
          this.router.navigate([`/`]);
          this.layoutService.openErrorDialog(ErrorType.TOO_MANY_REQUESTS, err.error.message);
        } else if (err.url.includes('givex/verify/user')) {
          // handle is user registered in inspiredrewards to claim promo
          // any error by givex/verify/use -> redirect to not registered page

          this.localStorageService.removeItem(TOKEN_KEY);
          this.phoneConfirmationService.phoneConfirmed.set(false);

          this.router.navigate([`/promo/not-registered`]);

        } else if (err.url.includes('lco/verify') && err.error && err.error.payload && typeof err.error.payload === 'string') {
          this.localStorageService.removeItem(TOKEN_KEY);
          this.layoutService.openErrorDialog(ErrorType.UNKNOWN, err.error.payload);
        } else if ((err.url.includes('givex/qr/summary') || err.url.includes('givex/promo/apply')) && err.status === 400) {
          this.router.navigate([`/`]);
          this.layoutService.openServerErrorDialog();
        } else if (err.error && err.error.payload && typeof err.error.payload === 'string') {
          if (err.error.payload.toLowerCase().includes('not authorized')) {
            this.localStorageService.removeItem(TOKEN_KEY);
            this.router.navigate([`/`]);
          } else if (err.error.payload === ErrorType.IP_CHECK) {
            this.layoutService.openErrorDialog(ErrorType.IP_CHECK, err.error.payload);
          } else if (err.error.payload.toLowerCase().includes('survey analytic')) {
            this.layoutService.openErrorDialog(ErrorType.ROLE_CHECK, err.error.payload);
          } else {
            this.layoutService.openErrorDialog(ErrorType.UNKNOWN, err.error.payload);
          }
        }

        return throwError(err);
      })
    );
  }
}
